module.exports = __webpack_public_path__ + "img/xsbh.9cfae228.png";